import actions from './actions';
import { exportCommonFile } from "../../../../helpers/utilities";

const initState = {
    loader: false,
    myProductdetails: '',
    error: '',
    productPriceLoader: false,
    productPrices: '',
    productPriceError: '',
    cProductLoader: false,
    cProduct: '',
    cProductError: ''
};

export default function productProductReducer(state = initState, action) {
    switch (action.type) {
        case actions.MYPRODUCT_DETAILS_START: {
            return {
                ...state,
                loader: true,
            };
        }
        case actions.MYPRODUCT_DETAILS_SUCCESS: {
            if (action.export) {
                exportCommonFile(action.export, action.payload, action.data, action.selected, action.extension);
            }
            return {
                ...state,
                loader: false,
                myProductdetails: action.payload,
            };
        }
        case actions.MYPRODUCT_DETAILS_FAILURE: {
            return {
                ...state,
                loader: false,
                error: action.message,
            };
        }
        case actions.PRODUCT_PRICE_START: {
            return {
                ...state,
                productPriceLoader: true
            };
        }
        case actions.PRODUCT_PRICE_SUCCESS: {
            return {
                ...state,
                productPriceLoader: false,
                productPrices: action.payload,
            };
        }
        case actions.PRODUCT_PRICE_FAILURE: {
            return {
                ...state,
                productPriceLoader: false,
                productPriceError: action.message,
            };
        }     

        case actions.CLEAR_PRICE_START: {
            return {
                ...state,
            };
        }
        case actions.CLEAR_PRICE_SUCCESS: {
            return {
                ...state,
                productPrices: ''
            };
        }
        default:
            return state;
    }
}